import axios from 'axios';
import { getContext } from '@fiverr-private/fiverr_context';
import pathfinder from '@fiverr-private/pathfinder';
import { logger } from '@fiverr-private/obs';
import * as sharedApi from '../../../../../shared/utils/api/collections';

export const updateCollection = ({ id, ...params }) => {
    const url = pathfinder('collections_lobby_update_collection', { collection_id: id });

    return sharedApi.updateCollection(url, params);
};

export const deleteCollection = (id) => {
    const url = pathfinder('collections_lobby_delete_collection', { collection_id: id });

    return sharedApi.deleteCollection(url);
};

export const shareWithTeam = ({ id, ...params }) => {
    const url = pathfinder('collections_lobby_share_collection_with_team', { collection_id: id });

    return sharedApi.shareWithTeam(url, params);
};

export const copyCollection = async (id, name, description) => {
    const { userId } = getContext();

    const url = pathfinder('collection_page_copy_to_my_lists', { collection_id: id });

    const params = { name, description };

    try {
        const { data } = await axios.post(url, params);

        return data.collection;
    } catch (error) {
        logger.error(error, {
            description: 'Failed to copy collection',
            collectionId: id,
            userId,
        });

        throw error;
    }
};
